import React, { Component } from "react";
import Control from "./control";

class Plain extends Component {
    state = {
        data: this.props.data,
        restData: this.props.restData,
        loaded: false,
        colsTemplateCount: 12,
        colsFormCount: 12,
    };

    constructor(props) {
        super(props);
        let manager = this.props.manager.state;
        let templateConfiguration = manager.module.templateConfiguration;
        if (templateConfiguration.events) {
            Object.keys(templateConfiguration.events).map((itm, idx) => {
                this[itm] = templateConfiguration.events[itm].bind(this);
            });
        }
        this.form = React.createRef();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.action) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        let manager = this.props.manager.state;
        let templateConfiguration = manager.module.templateConfiguration;
        const innerTemplates = [
            "tab",
            "header",
            "top",
            "right",
            "bottom",
            "left",
            "panelTop",
            "panelRight",
            "panelBottom",
            "panelLeft",
            "cardTop",
            "cardRight",
            "cardBottom",
            "cardLeft",
        ];

        innerTemplates.map((itm, idx) => {
            let tmp = templateConfiguration[itm + "Template"]
                ? templateConfiguration[itm + "Template"]
                : () => {};
            this[itm + "Template"] = tmp.bind(this);
        });

        let useCard =
            typeof templateConfiguration.useCard !== "undefined"
                ? templateConfiguration.useCard
                : true;

        let colsTemplateCount = templateConfiguration.colsTemplateCount
            ? templateConfiguration.colsTemplateCount
            : this.state.colsTemplateCount;
        let colsFormCount = templateConfiguration.colsFormCount
            ? templateConfiguration.colsFormCount
            : this.state.colsFormCount;

        this.setState({
            loaded: true,
            colsTemplateCount: colsTemplateCount,
            colsFormCount: colsFormCount,
            useCard: useCard,
        });

        if (this.didMount) {
            this.didMount();
        }
    }

    output() {
        let out = [];

        this.state.data.map((itm, idx) => {
            Object.keys(itm).map((objItm, objIdx) => {
                if (itm[objItm]["showPropertyOnTemplate"]) {
                    let ControlUI = (
                        <Control control={itm[objItm]} key={idx + "-" + objIdx}></Control>
                    );
                    out.push(ControlUI);
                    out.push(itm[objItm].validationComponent);
                }
            });
        });

        return out;
    }

    render() {
        if (this.state.loaded) {
            return (
                <React.Fragment>
                    {this.headerTemplate()}
                    {this.panelTopTemplate()}
                    <div className="container-fluid">
                        <div className="row">
                            {this.panelLeftTemplate()}
                            <div className={"col-md-" + this.state.colsTemplateCount}>
                                <div className="row">
                                    {this.leftTemplate()}
                                    <div className={"col-md-" + this.state.colsFormCount}>
                                        {this.topTemplate()}
                                        {this.state.useCard != false ? (
                                            <div className="card">
                                                <div className="card-body">
                                                    {this.cardTopTemplate()}
                                                    {this.output()}
                                                    {this.cardBottomTemplate()}
                                                </div>
                                            </div>
                                        ) : (
                                            <React.Fragment>
                                                {this.cardTopTemplate()}
                                                {this.output()}
                                                {this.cardBottomTemplate()}
                                            </React.Fragment>
                                        )}
                                        {this.bottomTemplate()}
                                    </div>
                                    {this.rightTemplate()}
                                </div>
                            </div>
                            {this.panelRightTemplate()}
                        </div>
                    </div>
                    {this.panelBottomTemplate()}
                </React.Fragment>
            );
        } else {
            return "loading...";
        }
    }
}

export default Plain;

